import React from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import Nav from 'components/Nav/Nav';
import Footer from 'components/Footer/Footer';

// 케어센스 OAuth 관련 에러 메시지 매핑
const ERROR_MESSAGES = {
  invalid_state: '유효하지 않은 인증 상태입니다. (State 불일치)',
  missing_params: '필수 파라미터가 누락되었습니다.',
  callback_failed: '인증 처리 중 오류가 발생했습니다.',
  // 참고: nonce 검증은 백엔드에서 id_token과 함께 수행됨
};

function ErrorPage() {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  // URL 파라미터에서 에러 정보 가져오기
  const reasonParam = searchParams.get('reason');
  const messageParam = searchParams.get('message');
  const codeParam = searchParams.get('code');

  // navigate로 전달된 state에서 에러 정보 가져오기 (기존 방식 호환)
  const stateMessage = location.state?.message;
  const stateCode = location.state?.code;

  // 최종 에러 메시지 결정
  let errorMessage = '접근 권한이 없습니다.';
  let errorCode = null;

  if (reasonParam && ERROR_MESSAGES[reasonParam]) {
    // reason 파라미터가 있으면 매핑된 메시지 사용
    errorMessage = ERROR_MESSAGES[reasonParam];
    errorCode = reasonParam;
  } else if (messageParam) {
    // message 파라미터가 있으면 직접 사용
    errorMessage = decodeURIComponent(messageParam);
    errorCode = codeParam;
  } else if (stateMessage) {
    // state로 전달된 메시지 사용 (기존 방식)
    errorMessage = stateMessage;
    errorCode = stateCode;
  }

  const errorContainerStyle = {
    height: '800px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: '100px',
  };
  const errorMessageStyle = {
    fontWeight: 700,
    fontSize: '18px',
    marginBottom: '10px',
  };
  const errorCodeStyle = {
    fontSize: '14px',
    color: '#666',
    marginTop: '10px',
  };

  return (
    <div>
      <Nav />
      <div className="error-container" style={errorContainerStyle}>
        <div className="error-message" style={errorMessageStyle}>
          {errorMessage}
        </div>
        {errorCode && (
          <div className="error-code" style={errorCodeStyle}>
            오류 코드: {errorCode}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default ErrorPage;
